import { all } from 'redux-saga/effects';
import authSagas from './Auth';
import billingSagas from './Billing';
import analyticSagas from './Analytic';
import catalogSagas from './Catalog';
import catalogSyncSagas from './catalogSyncSaga';
import settingsSagas from './Settings';
import settingsV2Sagas from './SettingsV2';
import recs from './Recs';
import search from './Search';
import notifications from './Notifications';
import errorHandlers from './ErrorHandlers';
import { sagas as Onboarding } from '../slices/OnboardingSlice';
import { sagas as Bridge } from '../slices/BridgeSlice';
import { sagas as Wizard } from '../slices/WizardSlice';
import wizardSaga from '../features/wizard/wizardSaga';

export default function* rootSaga() {
  yield all([
    catalogSagas(),
    catalogSyncSagas(),
    authSagas(),
    billingSagas(),
    analyticSagas(),
    settingsSagas(),
    settingsV2Sagas(),
    recs(),
    search(),
    notifications(),
    errorHandlers(),
    Onboarding(),
    Bridge(),
    Wizard(),
    wizardSaga(),
  ]);
}
